import * as React from 'react';
import { StaticLoadingWrapper, IconWrapper } from './styles.js';
import { LoadingState } from '../types.js';
import { IconType, Icon } from '@doordash/design-language';

var _IconTypeMap;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var IconTypeMap = (_IconTypeMap = {}, _defineProperty(_IconTypeMap, LoadingState.Success, IconType.CheckCircleLine), _defineProperty(_IconTypeMap, LoadingState.Error, IconType.CloseCircleLine), _IconTypeMap);

var StaticLoading = function StaticLoading(_ref) {
  var color = _ref.color,
      size = _ref.size,
      state = _ref.state;

  if (state !== LoadingState.Loading && state !== LoadingState.FoodLoop) {
    return /*#__PURE__*/React.createElement(StaticLoadingWrapper, {
      size: size
    }, /*#__PURE__*/React.createElement(IconWrapper, null, /*#__PURE__*/React.createElement(Icon, {
      type: IconTypeMap[state],
      color: color,
      size: size,
      shouldAdjustSmallSizesWhitespace: true
    })));
  }

  if (state === LoadingState.FoodLoop) {
    return /*#__PURE__*/React.createElement(StaticLoadingWrapper, {
      size: size
    }, /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1000 900",
      width: "".concat(size, "px"),
      height: "".concat(size, "px"),
      fill: "none",
      preserveAspectRatio: "xMidYMid meet",
      style: {
        width: '100%',
        height: '100%',
        transform: 'translate3d(0px, 0px, 0px)'
      }
    }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
      style: {
        display: 'block'
      },
      transform: "matrix(1,0,0,1,-460,-90)",
      opacity: "1"
    }, /*#__PURE__*/React.createElement("g", {
      transform: "matrix(1.4500000476837158,0,0,1.4500000476837158,-439.76397705078125,-243)",
      opacity: "1",
      style: {
        display: 'block'
      }
    }, /*#__PURE__*/React.createElement("g", {
      opacity: "1",
      transform: "matrix(1,0,0,1,966.14697265625,540.14697265625)"
    }, /*#__PURE__*/React.createElement("path", {
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      fillOpacity: "0",
      strokeMiterlimit: "4",
      strokeDasharray: " 20",
      strokeDashoffset: "0",
      stroke: color,
      strokeOpacity: "1",
      strokeWidth: "14",
      d: " M-176.54800415039062,-138.08399963378906 C-101.71499633789062,-167.23699951171875 32.45000076293945,-197.61700439453125 178.2830047607422,-126.69400024414062 C197.74000549316406,-117.23100280761719 205.5070037841797,-93.5999984741211 195.6280059814453,-74.35199737548828 C195.6280059814453,-74.35199737548828 32.99599838256836,242.5 32.99599838256836,242.5 C18.73900032043457,270.27801513671875 -20.868000030517578,270.5570068359375 -35.51599884033203,242.98300170898438 C-35.51599884033203,242.98300170898438 -235.63400268554688,-133.72799682617188 -235.63400268554688,-133.72799682617188 C-246.4600067138672,-154.10800170898438 -237.13499450683594,-179.36500549316406 -215.66299438476562,-187.81900024414062 C-136.9980010986328,-218.79100036621094 46.70399856567383,-270.5570068359375 216.9550018310547,-166.97500610351562 C222.9499969482422,-163.32699584960938 229.85299682617188,-161.4429931640625 236.87100219726562,-161.4429931640625 C236.87100219726562,-161.4429931640625 269.17401123046875,-161.4429931640625 269.17401123046875,-161.4429931640625 C273.8819885253906,-161.4429931640625 278.31500244140625,-160.26800537109375 282.1960144042969,-158.19400024414062"
    }))), /*#__PURE__*/React.createElement("g", {
      transform: "matrix(1.4500000476837158,0,0,1.4500000476837158,-439.76397705078125,-243)",
      opacity: "1",
      style: {
        display: 'block'
      }
    }, /*#__PURE__*/React.createElement("g", {
      opacity: "1",
      transform: "matrix(1,0,0,1,966.14697265625,540.14697265625)"
    }, /*#__PURE__*/React.createElement("path", {
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      fillOpacity: "0",
      strokeMiterlimit: "4",
      stroke: color,
      strokeOpacity: "1",
      strokeWidth: "14",
      d: " M-54.9119987487793,-167.81500244140625 C12.626999855041504,-174.92300415039062 93.48200225830078,-167.93499755859375 178.2830047607422,-126.69400024414062 C197.74000549316406,-117.23100280761719 205.5070037841797,-93.5999984741211 195.6280059814453,-74.35199737548828 C195.6280059814453,-74.35199737548828 32.99599838256836,242.5 32.99599838256836,242.5 C18.73900032043457,270.27801513671875 -20.868000030517578,270.5570068359375 -35.51599884033203,242.98300170898438 C-35.51599884033203,242.98300170898438 -55.75899887084961,204.87600708007812 -83.36900329589844,152.9029998779297"
    }))), /*#__PURE__*/React.createElement("g", {
      transform: "matrix(1.4500000476837158,0,0,1.4500000476837158,-423.594970703125,-243)",
      opacity: "1",
      style: {
        display: 'block'
      }
    }, /*#__PURE__*/React.createElement("g", {
      opacity: "1",
      transform: "matrix(1,0,0,1,897.2520141601562,474.2950134277344)"
    }, /*#__PURE__*/React.createElement("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fillOpacity: "0",
      stroke: color,
      strokeOpacity: "1",
      strokeWidth: "14",
      d: " M36.5359992980957,4.802999973297119 C34.18199920654297,22.882999420166016 18.72100067138672,36.84600067138672 0,36.84600067138672 C-20.349000930786133,36.84600067138672 -36.84600067138672,20.349000930786133 -36.84600067138672,0 C-36.84600067138672,-20.349000930786133 -20.349000930786133,-36.84600067138672 0,-36.84600067138672 C20.349000930786133,-36.84600067138672 36.84600067138672,-20.349000930786133 36.84600067138672,0"
    })), /*#__PURE__*/React.createElement("g", {
      opacity: "1",
      transform: "matrix(1,0,0,1,979.2310180664062,669.9119873046875)"
    }, /*#__PURE__*/React.createElement("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fillOpacity: "0",
      stroke: color,
      strokeOpacity: "1",
      strokeWidth: "14",
      d: " M30.20599937438965,3.9709999561309814 C28.260000228881836,18.917999267578125 15.47700023651123,30.461999893188477 0,30.461999893188477 C-16.823999404907227,30.461999893188477 -30.461999893188477,16.822999954223633 -30.461999893188477,0 C-30.461999893188477,-16.823999404907227 -16.823999404907227,-30.461999893188477 0,-30.461999893188477 C16.822999954223633,-30.461999893188477 30.461999893188477,-16.823999404907227 30.461999893188477,0"
    })), /*#__PURE__*/React.createElement("g", {
      opacity: "1",
      transform: "matrix(1,0,0,1,923.7650146484375,571.9130249023438)"
    }, /*#__PURE__*/React.createElement("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fillOpacity: "0",
      stroke: color,
      strokeOpacity: "1",
      strokeWidth: "14",
      d: " M37.71500015258789,-2.135999917984009 C29.415000915527344,-4.297999858856201 -8.04800033569336,-11.975000381469727 -39.395999908447266,15.609999656677246"
    })), /*#__PURE__*/React.createElement("g", {
      opacity: "1",
      transform: "matrix(1,0,0,1,1033.5179443359375,502.8349914550781)"
    }, /*#__PURE__*/React.createElement("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fillOpacity: "0",
      stroke: color,
      strokeOpacity: "1",
      strokeWidth: "14",
      d: " M15.743000030517578,46.25699996948242 C16.69099998474121,35.16400146484375 18.304000854492188,-14.447999954223633 -23.86199951171875,-48.512001037597656"
    })))))));
  }

  return /*#__PURE__*/React.createElement(StaticLoadingWrapper, {
    size: size
  }, /*#__PURE__*/React.createElement("svg", {
    width: "".concat(size, "px"),
    height: "".concat(size, "px"),
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "14",
    stroke: color,
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeDasharray: "6 6"
  })));
};

export { StaticLoading as default };
